import { NgModule } from "@angular/core";
import { AsyncPipe, CommonModule } from "@angular/common";
import { GridDynamicWidgetComponent } from "@modules/grid/components/grid-dynamic-widget/grid-dynamic-widget.component";
import { DynamicComponent, DynamicIoDirective } from "ng-dynamic-component";
import { WidgetSettingsModalComponent } from "@modules/grid/components/widget-settings-modal/widget-settings-modal.component";
import {
  HardBtnComponent,
  HardFormModule,
  HardLoadingComponent,
  HardModalComponent,
  HardNoDataComponent,
  HardPermissionDirective,
  HardTranslatePipe,
} from "@hardcode-kz/ui";
import { ReactiveFormsModule } from "@angular/forms";
import { MatTab, MatTabGroup, MatTabLabel } from "@angular/material/tabs";
import { TruncatePipe } from "@dmms/shared/utils/pipes";
import { RoleNamesPipe } from "@modules/grid/pipes/role-names.pipe";
import { StopPropagationDirective } from "@dmms/shared/utils/directives";

@NgModule({
  declarations: [
    GridDynamicWidgetComponent,
    WidgetSettingsModalComponent,
    RoleNamesPipe,
  ],
  imports: [
    HardPermissionDirective,
    CommonModule,
    DynamicComponent,
    DynamicIoDirective,
    HardModalComponent,
    HardBtnComponent,
    ReactiveFormsModule,
    MatTabGroup,
    MatTab,
    HardFormModule,
    HardLoadingComponent,
    HardNoDataComponent,
    HardTranslatePipe,
    MatTabLabel,
    AsyncPipe,
    TruncatePipe,
    StopPropagationDirective,
  ],
  exports: [WidgetSettingsModalComponent],
  providers: [HardTranslatePipe],
})
export class GridModule {}
